import { render, staticRenderFns } from "./companyBox.vue?vue&type=template&id=2f6c1976&"
import script from "./companyBox.vue?vue&type=script&lang=ts&"
export * from "./companyBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports